export default __webpack_public_path__ + "static/media/BG.01a03138.png";